export const VEO_MODELS = {
    'veo-3.1': {
        id: 'veo-3.1',
        name: 'Google Veo 3.1',
        vertexModel: 'veo-3.1-generate-001',
        description: 'Максимальное качество, звук и диалоги, 1080p, первый и последний кадр',
        supportedDurations: [4, 6, 8],
        defaultDuration: 8,
        aspectRatios: ['16:9', '9:16'],
        supportsImageToVideo: true,
        supportsAudio: true,
        supportsLastFrame: true,
        supportsReferenceImages: true,
        maxAssetReferences: 3,
        supportsExtension: true,
        maxResolution: '1080p',
    },
    'veo-3.1-fast': {
        id: 'veo-3.1-fast',
        name: 'Google Veo 3.1 Fast',
        vertexModel: 'veo-3.1-fast-generate-001',
        description: 'Veo 3.1 быстрее, звук на месте — оптимальный выбор',
        supportedDurations: [4, 6, 8],
        defaultDuration: 8,
        aspectRatios: ['16:9', '9:16'],
        supportsImageToVideo: true,
        supportsAudio: true,
        supportsLastFrame: true,
        supportsReferenceImages: true,
        maxAssetReferences: 3,
        supportsExtension: true,
        maxResolution: '1080p',
    },
    'veo-3.1-lite': {
        id: 'veo-3.1-lite',
        name: 'Google Veo 3.1 Lite',
        vertexModel: 'veo-3.1-lite-generate-001',
        description: 'Самый дешёвый Veo 3.1, 720p — для черновиков и проб',
        supportedDurations: [4, 6, 8],
        defaultDuration: 8,
        aspectRatios: ['16:9', '9:16'],
        supportsImageToVideo: true,
        supportsAudio: true,
        // Conservatively false: the lite tier was verified to generate, but its
        // last-frame support was not, and claiming a capability the model lacks
        // fails at generation time rather than at selection time.
        supportsLastFrame: false,
        supportsReferenceImages: true,
        maxAssetReferences: 3,
        supportsExtension: false,
        maxResolution: '720p',
    },
};
// Veo 2.0, 3.0 and 3.0-fast were removed on 2026-08-07, not deprecated on a whim:
// Vertex answers NOT_FOUND for all three in this project, in every region tried
// (us-central1, us-east4, global), while the 3.1 family generates normally. Verified
// twice — through the REST API and by generating a clip from the Cloud console under
// owner credentials. Offering a model the backend cannot reach turns a working picker
// into a menu of dead options, so they are gone rather than left as decoration.
export const VIDEO_MODEL_LIST = Object.values(VEO_MODELS);
export const VIDEO_MODEL_IDS = Object.keys(VEO_MODELS);
export const DEFAULT_VIDEO_MODEL_ID = 'veo-3.1-fast';
// Every Imagen entry was removed on 2026-08-07 for the same reason as Veo 2 and 3:
// Vertex answers NOT_FOUND for imagen-4.0-generate-001, imagen-4.0-fast-generate-001,
// imagen-4.0-ultra-generate-001 and imagen-3.0-generate-002 in us-central1, us-east4,
// europe-west4 and asia-southeast1 alike. gemini-2.5-flash-image is the only image
// model this project can still reach, so it is also the default — the previous default
// pointed at imagen-4, which means image generation failed out of the box.
export const IMAGE_MODELS = {
    'gemini-image': {
        id: 'gemini-image',
        name: 'Google Gemini Image',
        vertexModel: 'gemini-2.5-flash-image',
        kind: 'gemini',
        supportsEditing: true,
        description: 'Редактирование готового фото текстом — фон, объекты, стиль',
    },
};
export const IMAGE_MODEL_LIST = Object.values(IMAGE_MODELS);
export const IMAGE_MODEL_IDS = Object.keys(IMAGE_MODELS);
export const DEFAULT_IMAGE_MODEL_ID = 'gemini-image';
export const STYLE_PRESETS = [
    'Cinematic',
    'UGC',
    'App Promo',
    'Product Demo',
    'Character Story',
    'Social Ad',
];
export const CAMERA_MOTIONS = [
    'Static',
    'Zoom in',
    'Dolly in',
    'Handheld',
    'Orbit',
    'Pan',
];
export const VIDEO_DURATIONS = [4, 5, 6, 7, 8];
export const ASPECT_RATIOS = ['16:9', '9:16', '1:1'];
export function getVeoModel(id) {
    return VEO_MODELS[id];
}
export function requireVeoModel(id) {
    const spec = VEO_MODELS[id];
    if (!spec) {
        throw new Error(`Unknown Veo model: ${id}. Available: ${VIDEO_MODEL_IDS.join(', ')}.`);
    }
    return spec;
}
export function getImageModel(id) {
    return IMAGE_MODELS[id];
}
export function requireImageModel(id) {
    const spec = IMAGE_MODELS[id];
    if (!spec) {
        throw new Error(`Unknown image model: ${id}. Available: ${IMAGE_MODEL_IDS.join(', ')}.`);
    }
    return spec;
}
const DEFAULT_ASPECT_RATIO = '16:9';
export function resolveAspectRatio(spec, requested) {
    const wanted = requested.trim() || DEFAULT_ASPECT_RATIO;
    const match = spec.aspectRatios.find((ratio) => ratio === wanted);
    if (match)
        return match;
    const available = spec.aspectRatios.join(', ');
    throw new Error(`Model ${spec.id} does not support the ${wanted} aspect ratio. Available: ${available}.`);
}
/**
 * Snaps instead of rejecting: the UI offers a near-continuous duration control and a
 * one-second mismatch is not worth failing a generation over.
 */
export function resolveDuration(spec, requested) {
    if (!Number.isFinite(requested))
        return spec.defaultDuration;
    let closest = spec.defaultDuration;
    let smallestGap = Number.POSITIVE_INFINITY;
    for (const candidate of spec.supportedDurations) {
        const gap = Math.abs(candidate - requested);
        if (gap < smallestGap) {
            smallestGap = gap;
            closest = candidate;
        }
    }
    return closest;
}
//# sourceMappingURL=models.js.map